import React from "react";

const Tab = ({ active, label, icon, onClick, testId }) => (
  <button
    data-testid={testId}
    aria-label={label}
    onClick={onClick}
    className={`flex-1 h-12 rounded-2xl flex flex-col items-center justify-center gap-0.5 border transition active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-600/35 ${
      active ? "bg-ink-900 text-white border-white/10" : "bg-white text-slateLux-500 border-pearl-200 hover:bg-pearl-50"
    }`}
  >
    <div className="text-[16px] leading-none">{icon}</div>
    <div className="text-[10px] font-semibold tracking-wide">{label}</div>
  </button>
);

export default function MobileBottomNav({ activePage, onNavigate }) {
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed left-3 right-3 z-50 md:hidden"
      style={{
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)"
      }}
    >
      <div className="bg-white/82 backdrop-blur border border-pearl-200 rounded-[26px] shadow-lux p-2 flex gap-2">
        <Tab testId="mobile-tab-mail" active={activePage === "mail"} label="Mail" icon="✉" onClick={() => onNavigate("mail")} />
        <Tab testId="mobile-tab-dms" active={activePage === "social"} label="DMs" icon="💬" onClick={() => onNavigate("social")} />
        <Tab testId="mobile-tab-chat" active={activePage === "chat"} label="Chat" icon="🧠" onClick={() => onNavigate("chat")} />
        <Tab testId="mobile-tab-settings" active={activePage === "settings"} label="Settings" icon="⚙" onClick={() => onNavigate("settings")} />
      </div>
    </nav>
  );
}

